const { legType } = require('../master-indent/type');

const importExportType = {
  EXPORT: 1,
  IMPORT: 2,
};

const eximMovementType = {
  FCL: 1,
  LCL: 2,
  ROAD: 3,
  CARGO: 4,
  COURIER: 5,
  COMMERCIAL: 6,
};

const eximMovementTypeDetails = [
  {
    id: 1,
    display_label: 'FCL',
    group_type: legType.OCEAN,
  },
  {
    id: 2,
    display_label: 'LCL',
    group_type: legType.OCEAN,
  },
  {
    id: 3,
    display_label: 'ROAD',
    group_type: legType.ROAD,
  },
  {
    id: 4,
    display_label: 'Cargo',
    group_type: legType.AIR,
  },
  {
    id: 5,
    display_label: 'Courier',
    group_type: legType.AIR,
  },
  {
    id: 6,
    display_label: 'Commercial',
    group_type: legType.AIR,
  },
];

module.exports = {
  importExportType,
  eximMovementType,
  eximMovementTypeDetails,
};
